'use client';

import { useRouter } from 'next/navigation';

import { CloseIcon } from '~/assets/icons';
import { closeCurrentModal } from '~/utils/mobileApp';

type Props = {
  path?: string;
  /**
   * 닫기 직전에 호출되어 닫기 진행 여부를 결정한다.
   * true 반환 시 닫기 진행, false 반환 시 취소.
   */
  onBeforeClose?: () => Promise<boolean> | boolean;
};

export function CloseCurrentButton({ path, onBeforeClose }: Props) {
  const router = useRouter();
  const handleClose = async () => {
    if (onBeforeClose) {
      const shouldClose = await onBeforeClose();
      if (!shouldClose) return;
    }

    if (path) {
      router.replace(path);
      return;
    }

    closeCurrentModal();
  };

  return (
    <button type="button" onClick={handleClose} className="size-24">
      <CloseIcon className="" />
    </button>
  );
}
